import React from 'react';
import { Card, Row, Col, Breadcrumb } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

const RewardsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rewards = location.state?.rewards || [];


  const goHomeButton = () => {
    const yinzcamId = localStorage.getItem("yinzcamId");
    const email = localStorage.getItem("email");
    navigate(`/?yinzcamId=${yinzcamId}&email=${email}`);
  };

  const handleCardClick = (badgeId) => {
    navigate(`/badge/${badgeId}`);
  };

  const cardStyle = {
    width: '100%',
    marginBottom: '10px',
    border: '1px solid #393836',
    borderRadius: '5px',
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: 'black',
    padding: '0px',
  };

  const imageStyle = (imageUrl) => ({
    width: '100%',
    height: '70px',
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    objectFit: 'contain',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: '1px solid #393836',
    padding: '20px 0',
  });



  const headlineStyle = (fontSize, color) => ({
    margin: 0,
    marginBottom: '8px',
    fontSize: `${fontSize}px`,
    color: color || '#fff',
    fontWeight: 'bold',
  });

 
  const footerStyle = {
    padding: '10px',
  };

  return (
    <div style={{ padding: '20px', background: '#000', minHeight: '100vh' }}>
      <style>
        {`
          .reward-description h1 {
            margin: 0;
          }
        `}
      </style>
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            onClick={goHomeButton}
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
              fontSize: "13px",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            <ArrowLeftOutlined
              style={{
                display: "flex",
                padding: "10px",
                fontSize: "18px",
                color: "white",
              }}
            />
            <span>Home</span>
          </div>
          <div style={{
            color: '#ffffff57',
            margin: '0 10px',
            fontSize: '13px'
          }}>
            /
          </div>
          <div style={{
            color: 'white',
            fontSize: '13px'
          }}>
            Rewards
          </div>
        </div>
      </div>

      <Row gutter={[16, 16]}>
        {rewards.length > 0 ? (
          rewards.map((reward) => reward.rewardDetails?.imageURL ? (
            <Col xs={24} sm={24} md={12} lg={8} key={reward.badgeId}>
              <Card
                style={cardStyle}
                bodyStyle={{ padding: 0 }}
                cover={<div style={imageStyle(reward.rewardDetails.imageURL)} />}
                onClick={() => handleCardClick(reward.badgeId)}
              >
                <div style={footerStyle}>
                  <h3 
                    style={headlineStyle(
                      reward.rewardDetails.headlineFontSize,
                      reward.rewardDetails.headlineFontColor
                    )}
                  >
                    {reward.rewardDetails.headline}
                  </h3>
                  <div className='reward-description'
                    style={{
                      margin: 0,
                      fontSize: `${reward.rewardDetails.descriptionFontSize || 14}px`,
                      color: reward.rewardDetails.descriptionFontColor || '#fff',
                    }}
                    dangerouslySetInnerHTML={{ 
                      __html: reward.rewardDetails.rewardDescription 
                    }}
                  />
                </div>
              </Card>
            </Col>
          ) : null)
        ) : (
          <Col span={24}>
            <div style={{ color: '#fff', textAlign: 'center', marginTop: '20px' }}>
              No rewards available
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default RewardsPage; 